export default __webpack_public_path__ + "static/media/error.89bd4b21.svg";